const ScrollTarget = React.forwardRef(({
    className,
    offset = 0,
    offsetDown = 0,
    offsetUp = 0,
    children
}, ref) => {
    
    const divRef = React.useRef();

    React.useImperativeHandle(ref, () => ({
        scroll: (time = 500) => {
            const $this = $(divRef.current);
            const containerHeight = $this.height();
            $this.css({ height: containerHeight });
            window.isAnimatedScrolling = true
            const finalOffset = $this.offset().top >= $(window).scrollTop()
                ? (offsetDown || offset)
                : (offsetUp || offset)
            $('html, body').animate({ scrollTop: $this.offset().top + finalOffset }, time, () => {
                $this.css({ height: 'unset' });
                setTimeout(() => {
                    window.isAnimatedScrolling = false
                }, 100)
            });
        }
    }));
    
    return <div className={className} ref={divRef}>{children}</div>;
});

export default ScrollTarget;